import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import TabHeader from '@/components/TabHeader/TabHeader';
import DataTable from '@/components/DataTable/DataTable';
import { dataType } from '@/constants/data-type';
import { CUSTOM_STYLES } from '@/constants/app';
import "@/assets/styles/components/my-account/currency-balance.scss";
import { getAccountBalanceAction } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import { Comparator } from '@/helpers/functions';
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';

class AccountBalance extends React.Component {
  constructor(props) {
    super(props)
    props.innerRef(this)
    this.state = {
      accountBalance: [{ id: 1, title: 'account_balance_title', isActive: false }],
      accountBalanceData: null,
      columnDefs: [
        {
          headerName: props.language.common_currency,
          colId: 'common_currency',
          field: 'currencyID',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.TEXT,
          minWidth: 80
        },
        {
          headerName: props.language.common_buying_power,
          colId: 'common_buying_power',
          field: 'buyingPower',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          bindingColor: true,
          minWidth: 110
        },
        {
          headerName: props.language.common_due_balance,
          colId: 'common_due_balance',
          field: 'dueBalance',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 110
        },
        {
          headerName: props.language.current_account_settled_balance,
          colId: 'current_account_settled_balance',
          field: 'settledBalance',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 120
        },
        {
          headerName: props.language.current_account_withdrawable_balance,
          colId: 'current_account_withdrawable_balance',
          field: 'withdrawableBalance',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 160
        },
        {
          headerName: props.language.current_account_ledger_balance,
          colId: 'current_account_ledger_balance',
          field: 'ledgerBalance',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 120
        }
      ],
    }
  }

  getAccountBalanceData = () => {
    const { user, language, currentTradingAccount } = this.props;
    const { clientID } = currentTradingAccount;
    const params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.SHOW_DETAILS]: 'Y'
    }
    this.accountBalanceTableRef.toggleLoadingOverlay(true);
    this.props.getAccountBalanceAction(params, res => {
      if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          accountBalanceData: res.result.detailsList
        })
      } else {
        this.setState({ accountBalanceData: [] })
      }
      this.accountBalanceTableRef.toggleLoadingOverlay(false);
    })
  }

  componentDidMount() {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount) {
      this.getAccountBalanceData()
    }
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getAccountBalanceData()
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

  render() {
    const { accountBalance, columnDefs, accountBalanceData } = this.state;

    return (
      <React.Fragment>
        <div className="account-balance-container">
          <section className="stock-table" style={{width:"768px" }} >
            <TabHeader tabs={accountBalance} customStyle={CUSTOM_STYLES.HEADER_NORMAL} />
            <DataTable 
              name={TABLE_CONFIGURABLE_KEYS.MY_ACCOUNT_ALL_ACCOUNT_BALANCE}
              columnDefs={columnDefs}
              data={accountBalanceData}
              innerRef={e => this.accountBalanceTableRef = e}
              showPagination = {false}></DataTable>
          </section>
        </div>

      </React.Fragment>
    )
  }

}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  }),
  dispatch => ({
    getAccountBalanceAction: (p, c) => dispatch(getAccountBalanceAction(p, c))
  })
)(AccountBalance)